export enum FEATURE_FLAG_KEYS {
  NAME_STEP_WITH_NICKNAME = 'name_step_with_nickname',
  NAME_STEP_WITHOUT_NICKNAME = 'name_step_without_nickname',
  TT_SELECTION_PAGE_DEFAULT = 'tt_selection_page_default',
  TT_SELECTION_PAGE_SIMPLIFIED = 'tt_selection_page_simplified',
  SHOW_ADDITIONAL_PROFESSIONAL_LINK = 'show_additional_professional_link',
  HIDE_ADDITIONAL_PROFESSIONAL_LINK = 'hide_additional_professional_link',
}
